<template>
  <div class="fill_box">
    <router-view v-wechat-title='$route.meta.title'></router-view>
    <!-- <div v-if="true"> -->
    <div v-if="showPage">
      <!-- <img src="@/images/chat.png" class="chat_img" @click="gotoChat"> -->


      <img src="@/images/d1.png" alt class="status_img_in_detail" v-if="inquiryStatus==1" />
      <img src="@/images/d4.png" alt class="status_img_in_detail" v-if="inquiryStatus==3" />
      <img
        src="@/images/d3.png"
        alt
        class="status_img_in_detail"
        v-if="inquiryStatus==5"
        @click="goto(details.LoInquiryId)"
      />
      <div class="in_detail_refuse_box" v-if="inquiryStatus==99">
        <div class="in_detail_refuse_box_tip line2" v-if="refuseText.length>27">
          {{refuseText.slice(0,27)}}...
          <!-- <span class="span-more" @click="showRefusal(refuseText)"></span> -->
          <span class="span-more2" @click="showRefusal(refuseText)">
            查看更多
            <img src="@/images/more.png" style="width:10px;height:10px" />
          </span>
        </div>
        <div class="in_detail_refuse_box_tip line2" v-else>{{refuseText}}</div>
      </div>
      <p class="fill_box_tip">以下信息仅莲藕互联网医院审方使用，申请信息仅限医院可见</p>
      <!-- 用药人模块 -->
      <div class="medication_person">
        <div class="flex">
           <h3 class="title_text">用药人</h3>
            <!-- <div to="historyPerson" class="flex2 history_person" style="margin-right: 12px;">
              <div @click="showALLMsg=true" s>查看完整信息</div>
            </div>   -->
        </div>
        <div v-for="(item,index) in personList" :key="item.id" class="person_item">
          <div class="person_box flex2" v-if="index!=5">
            <h4 class="content_title">{{item.title}}</h4>
            <div>{{person[index].text||"未填写"}}</div>
            <div class="arrow_eye" v-if="item.id==1">
              <van-icon @click="showMsg(1)" :name="showIdCardMsg?'eye-o':'closed-eye'" size="24" color="#cccccc" />
            </div>
            <div class="arrow_eye" v-if="item.id==4">
              <van-icon @click="showMsg(2)" :name="showNumMsg?'eye-o':'closed-eye'" size="24" color="#cccccc" />
            </div>
            <!-- <div class="arrow_img" v-if="item.showArrow">
              <img src="../images/arrow_right.png" alt="箭头" />
            </div> -->
          </div>
          <div class="person_box flex2" v-if="index==3">
            <h4 class="content_title">体重</h4>
            <div>{{weight?weight+'kg':'未填写'}}</div>
            <div class="arrow_img"></div>
          </div>
          <div class="person_box flex2" v-if="index==5">
            <h4 class="content_title">{{personList[5].title}}</h4>
            <div class="fill_pad">
              <div v-if="showNoHisTip">{{person[5].text}}</div>
              <div class v-for="item in person[5].testList" :key="item.title">
                <div v-if="item.name">
                  <!-- {{item.title}}:{{item.name}} -->
                  <span class="colon">{{item.title}}：</span>{{item.name}}
                  <!-- <div class="colon">{{item.title}}：</div>
                  <div>{{item.name}}</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 使用药品模块 -->
      <!-- 使用药品模块 -->
      <use-drug-module :showBtn= 'false' :addDrugsList="uniteDrugsList" :showAddOrChange="false" titleTip="未添加药品"></use-drug-module>
      <!-- 线下已确诊疾病（可多选） -->
      <submit-disease :diseaseList="diseaseList" :showBorder="false" :showAdd="false"></submit-disease>

      <!-- <use-drug-module
        :addDrugsList="uniteDrugsList"
        :showAddOrChange="false"
        :showBtn= 'false'
        title="联合用药"
        titleTip="未添加药品"
      ></use-drug-module> -->
      <!-- 病历报告单图片 -->
      <div class="report_module module" v-if="imgList.length!=0">
        <h3 class="title_text">病历报告单图片</h3>
        <div class="imgList flex2">
          <!-- <img     /> -->
          <van-image
            :src="item.content?item.content:item.Url"
            v-for="(item,index) in imgList"
            class="uoload_img"
            :key="index"
            @click="ImagePreviewClick(item,index)"
          />
        </div>
      </div>

      <div class="symptom_description module" v-if="false">
        <h3 class="title_text border1">症状描述</h3>
        <div class="back_details">{{description?description:"无"}}</div>
      </div>
      <!-- 尾部保存按钮 -->
      <div class="footer flex3 flex3s">
        <!-- <div class="change_btn" v-if="status" @click="changeData">修改</div> -->
        <!-- <div class="back_btn change_btn" @click="back">返回</div> -->
      </div>
      <van-image-preview v-model="bigImg" :images="[bigImgUrl]"></van-image-preview>
      <!-- 查看完整信息弹出 -->
      <!-- <van-popup v-model="showALLMsg"  round position="bottom" :style="{ height: '30%' }" class="flex2">
        <div class="" style="flex: 1;padding: 0 20px;">
          <div class="person_box flex2">
            <h4 class="content_title">身份证号</h4>
            <div>{{EncodeData.IDCard?EncodeData.IDCard:'未填写'}}</div>
            <div class="arrow_img"></div>
          </div>
          <div class="person_box flex2" >
            <h4 class="content_title">手机号码</h4>
            <div>{{EncodeData.MobilePhone?EncodeData.MobilePhone:'未填写'}}</div>
            <div class="arrow_img"></div>
          </div>
        </div>
      </van-popup> -->
    </div>
    <div>
      

    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import searchDisease from "@/components/search_disease.vue";
import diseaseHistory from "@/components/diseaseHistory.vue";
import useDrugModule from "@/components/fill-inquiry-information/useDrugModule.vue";
import submitDisease from "@/components/fill-inquiry-information/submitDisease.vue";
import { GetInquiry ,GetInquiryEncodeData} from "@/utils/api.js";
import { Toast, Dialog, } from "vant";
import {getBrowser} from "@/utils/common"
export default {
  name: "fill_box",
  components: {
    searchDisease,
    diseaseHistory,
    useDrugModule,
    submitDisease
  },
  computed: {
    showIdCardMsg() {
      return this.person[1].text == this.EncodeData.IDCard
    },
    showNumMsg() {
      return this.person[4].text == this.EncodeData.MobilePhone
    }
  },
  data() {
    return {
      EncodeData:{},
      showALLMsg:false,//查看完整手机号的弹框
      details:{},
      refuseText: "",
      inquiryStatus: 0,
      showPage: false,
      oldHisTip: "",
      showNoHisTip: false,
      onlyDrugsList: [],
      uniteDrugsList: [],
      bigImgUrl: "",
      bigImg: false, //展示大图
      weight: "",
      PatientId: "", //患者ID
      InquiryId: "", //就诊ID
      status: false,
      showHistoryDis: false,
      // hsitoryDisList:["过往病史", "过敏史", "家族病史", "妊娠哺乳", "肝功能","肾功能"],
      hsitoryDisList: [
        {
          type: 0,
          name: "过往病史",
          radio: "0",
          text1: "有",
          text2: "无",
          medList: [
            { name: "先天性心脏病", sel: false, sys: true },
            { name: "阴道炎", sel: false, sys: true },
            { name: "月经失调", sel: false, sys: true },
            { name: "肿瘤", sel: false, sys: true },
            { name: "动脉硬化", sel: false, sys: true },
            { name: "脑血管病", sel: false, sys: true },
            { name: "糖尿病", sel: false, sys: true }
          ],
          showAdd: true
        },
        {
          type: 1,
          name: "过敏史",
          radio: "0",
          text1: "有",
          text2: "无",
          medList: [
            { name: "青霉素", sel: false, sys: true },
            { name: "动物皮屑", sel: false, sys: true },
            { name: "尘螨", sel: false, sys: true },
            { name: "灰尘", sel: false, sys: true },
            { name: "花粉", sel: false, sys: true },
            { name: "鸡蛋", sel: false, sys: true },
            { name: "牛奶", sel: false, sys: true },
            { name: "鱼,虾,海产品", sel: false, sys: true },
            { name: "阿司匹林", sel: false, sys: true }
          ],
          showAdd: true
        },
        {
          type: 2,
          name: "家族病史",
          radio: "0",
          text1: "有",
          text2: "无",
          medList: [
            { name: "先天性心脏病", sel: false, sys: true },
            { name: "阴道炎", sel: false, sys: true },
            { name: "月经失调", sel: false, sys: true },
            { name: "肿瘤", sel: false, sys: true },
            { name: "动脉硬化", sel: false, sys: true },
            { name: "脑血管病", sel: false, sys: true },
            { name: "糖尿病", sel: false, sys: true }
          ],
          showAdd: true
        },
        {
          type: 3,
          name: "妊娠哺乳",
          radio: "0",
          text1: "有",
          text2: "无",
          medList: [
            { name: "备孕中", sel: false, sys: true },
            { name: "怀孕中", sel: false, sys: true },
            { name: "正在哺乳", sel: false, sys: true }
          ],
          showAdd: false
        },
        {
          type: 4,
          name: "肝功能",
          radio: "0",
          text1: "异常",
          text2: "正常",
          medList: [],
          showAdd: false
        },

        {
          type: 5,
          name: "肾功能",
          radio: "0",
          text1: "异常",
          text2: "正常",
          medList: [],
          showAdd: false
        }
      ],
      showDisModule: false, //显示添加疾病模块
      description: "", //描述
      minDate: new Date("1990-01-01"), //出生日期
      currentDate: new Date(), //出生日期
      maxDate: new Date(), //出生日期
      imgList: [],
      showDate: false, //选择出生日期模块
      addDrugsList: [], //使用药品列表
      searchDiseaseList: [], //搜索框的疾病列表
      diseaseList: [],
      person: [
        {
          text: "",
          tip: "name"
        },
        {
          text: "",
          tip: "carId"
        },
        {
          text: "",
          tip: "bornDate"
        },
        {
          text: "",
          tip: "sex"
        },
        {
          text: "",
          tip: "phone"
        },
        {
          testList: [
            { name: "", title: "过往病史" },
            { name: "", title: "过敏史" },
            { name: "", title: "家族病史" },
            { name: "", title: "妊娠哺乳" },
            { name: "", title: "肝功能" },
            { name: "", title: "肾功能" }
          ],
          text: "",
          tip: "about"
        }
      ],
      personList: [
        {
          title: "名字",
          tip: "用药人姓名",
          showArrow: false,
          inputType: "text",
          disable: true,
          id: 0
        },
        {
          title: "身份证号",
          tip: "用药人身份证号",
          showArrow: false,
          inputType: "number",
          disable: true,
          id: 1
        },
        {
          title: "出生日期",
          tip: "请选择出生年月",
          showArrow: false,
          inputType: "text",
          disable: true,
          id: 2
        },
        {
          title: "性别",
          tip: "sex",
          showArrow: false,
          inputType: "text",
          disable: true,
          id: 3
        },
        {
          title: "手机号码",
          tip: "用于接受医生回复提醒",
          showArrow: false,
          inputType: "number",
          disable: true,
          id: 4
        },
        {
          title: "疾病史",
          tip: "请选择",
          showArrow: false,
          inputType: "text",
          disable: true,
          id: 5
        }
      ],
      iDCard_old:'',
      mobilephone_old:''
    };
  },
  methods: {
    //展示或隐藏敏感信息
    showMsg(type) {
      console.log(this.person[1].text);
      console.log(this.EncodeData.IDCard);
      if(type==1){
        if(this.person[1].text == this.EncodeData.IDCard){
          this.person[1].text = this.iDCard_old
        }else{
          this.person[1].text = this.EncodeData.IDCard?this.EncodeData.IDCard:'未填写'
        }
      }else{
        if(this.person[4].text == this.EncodeData.MobilePhone){
          this.person[4].text = this.mobilephone_old
        }else{
          this.person[4].text = this.EncodeData.MobilePhone?this.EncodeData.MobilePhone:'未填写'
        }
      }
    },
    gotoChat(){
      this.$store.commit("changeInts",1)
      let browser = getBrowser()
      let GroupId = this.details.GroupId;

      // alert(GroupId)
      if (browser.isIOS && GroupId) {
          window.webkit.messageHandlers.chatGroup.postMessage(
            JSON.stringify({ GroupId, InquiryId: this.details.InquiryId })
          );
      } else if (browser.isAndroid && GroupId) {
          window.chat.chatGroup(GroupId, this.details.InquiryId);
      }
    },
    showRefusal(refuseText) {
      Dialog.alert({
        title: "拒绝原因",
        message: refuseText
      }).then(() => {
        // on close
      });
    },
    goto(InquiryId) {
      this.$router.push({
        path: "/prescriptionDetail",
        query: { InquiryId }
      });
    },
    ImagePreviewClick(item, i) {
      this.bigImgUrl = item.content
      this.bigImg = true
      // let imgArr = this.imgList.map(item => {
      //   return item.content;
      // });
      // const img = ImagePreview({
      //   images: [...imgArr],
      //   startPosition: i,
      //   closeOnPopstate: true,
      //   onClose() {
      //     img.close();
      //   }
      // });
    },

    // 修改
    // changeData(types) {
    //   Toast.loading({
    //     message: "加载中",
    //     duration: 0
    //   });
    //   if (this.onlyDrugsList[0]) {
    //     if (this.onlyDrugsList[0].DiseaseList.length > 0) {
    //       this.onlyDrugsList[0].DiseaseList.map(item => {
    //         this.diseaseList.map(items => {
    //           if (item.Name == items.Name) {
    //             items.sys = true;
    //           }
    //         });
    //       });
    //     }
    //   }
    //   this.hsitoryDisList[4].medList = [];
    //   this.hsitoryDisList[5].medList = [];
    //   sessionStorage.setItem(
    //     "fillData",
    //     JSON.stringify({
    //       currentDate: this.currentDate,
    //       diseaseList: this.diseaseList,
    //       person: this.person,
    //       imgList: this.imgList,
    //       description: this.description,
    //       addDrugsList: this.addDrugsList,
    //       hsitoryDisList: this.hsitoryDisList,
    //       weight: this.weight
    //     })
    //   );
    //   Toast.clear();
    //   sessionStorage.setItem("firstHis", true);
    //   if(types==1){
    //     this.$router.replace({
    //       path: "/fill",
    //       query: {
    //         PatientId: this.PatientId,
    //         InquiryId: this.InquiryId,
    //         type: "change",
    //          ModeType:this.details.ModeType
    //       }
    //     });
    //   }
    //   if (this.$route.query.status == 99) {
    //     this.$router.push({
    //       path: "/fill",
    //       query: {
    //         type: "change",
    //         ModeType:this.details.ModeType
    //       }
    //     });
    //   } else {
    //     console.log(this.details)
    //     this.$router.push({
    //       path: "/fill",
    //       query: {
    //         PatientId: this.PatientId,
    //         InquiryId: this.InquiryId,
    //         type: "change",
    //          ModeType:this.details.ModeType
    //       }
    //     });
    //   }
    // },
    back() {
      sessionStorage.removeItem("fillData");
      this.$router.go(-1);
    },
    //获取加密信息
    getEcoData(){
       GetInquiryEncodeData({
        inquiryId: this.$route.query.InquiryId
      }).then(res => {
        if (res.code == 1) {
          this.EncodeData={...res.data}
        }
      })
    },
    getData() {
      GetInquiry({
        inquiryId: this.$route.query.InquiryId
      }).then(res => {

        if (res.code == 1) {
          this.showPage = true;
          let data = res.data.Inq;
          let now = new Date(res.data.Inq.Birthday)
          var year = now.getFullYear();       
          var month = now.getMonth() + 1;  
          res.data.Inq.Birthday = year+"-"+month
          // 如果是已完成开方或者二审中，就不能修改
          // debugger
          if (data.Status == 5 || data.Status == 9) {
            this.status = false;
          } else {
            this.status = true;
          }
          this.details = data
           this.addDrugsList = res.data.Drugs;
          this.inquiryStatus = data.Status;
          this.InquiryId = data.InquiryId;
          this.PatientId = data.PatientId;
          this.currentDate = data.Birthdate;
         
          this.person[0].text = data.Name;
          this.person[1].text = data.IDCard; //
          this.iDCard_old = data.IDCard;
          this.mobilephone_old = data.Mobilephone
          this.person[2].text = data.Birthday //
          this.person[3].text = data.Sex == 1 ? "男" : data.Sex == 2?"女":"未知"; //
          this.person[4].text = data.Mobilephone; //
          this.hsitoryDisList[0].radio = data.PMHType == 0 ? 0 : 1; //过往病史 0=无；1=有；
          (this.hsitoryDisList[1].radio = data.AMHType == 0 ? 0 : 1), //过敏史0=无；1=有；
            (this.hsitoryDisList[2].radio = data.FMHType == 0 ? 0 : 1), //家族病史
            (this.hsitoryDisList[3].radio = data.NurseType == 0 ? 0 : 1), //是否妊娠哺乳0=无；1=有；
            (this.hsitoryDisList[4].radio = data.LiverType == 0 ? 0 : 1), //肝功能异常0=无；1=有；
            (this.hsitoryDisList[5].radio = data.RenalType == 0 ? 0 : 1), //肾功能异常0=无；1=有；



          this.diseaseList = res.data.Dis
          // debugger
          this.weight = data.Weight || "";
          this.diseaseList.map(item => {
            item.sel = true;
          });

          this.addDrugsList.map(item => {
            item.num = item.Count;
          });
          let tempList =  data.PicUrls?data.PicUrls.split(";"):[]
          tempList = tempList.splice(0,tempList.length-1)
          tempList.map(item => {
            this.imgList.push({
              content: item
            });
          });

          this.description = data.SymptomDesc;
          this.uniteDrugsList=this.addDrugsList
          // this.addDrugsList.map(item => {
          //   if (item.IsMain == 1) {
          //     this.onlyDrugsList.push(item);
          //   } else {
          //     item.IsMain == 0;
          //     this.uniteDrugsList.push(item);
          //   }
          // });
          this.person[5].testList[0].name = data.PMHDesc?data.PMHDesc:"";
          this.person[5].testList[1].name = data.AMHDesc?data.AMHDesc:"";
          this.person[5].testList[2].name = data.FMHDesc?data.FMHDesc:"";
          this.person[5].testList[3].name = data.NurseType==0? "":data.NurseDesc?data.NurseDesc:"";
          this.person[5].testList[4].name = data.LiverType==0? "":"异常";
          this.person[5].testList[5].name = data.RenalType==0? "":"异常";
          this.hsitoryDisList.map((item, index) => {
            let temArr = [];
            console.log(this.person[5].testList[index].name)
            let arr = this.person[5].testList[index].name.split("、");
            item.medList.map((it, inx) => {
              arr.map((items, indexs) => {
                if (items == it.name) {
                  it.sel = true;
                }
              });
            });
            // 判断返回的值是否存在不是系统默认的值
            arr.map((items, indexs) => {
              let count = item.medList.every((it, inx) => {
                return items != it.name;
              });
              if (count) {
                temArr.push({
                  sys: false,
                  sel: true,
                  name: items
                });
                temArr.map(items3 => {
                  if (items3.name) {
                    item.medList.push(items3);
                  }
                });
              }
            });

            // 判断是否显示疾病史：无
            if (
              this.person[5].testList.every(item => {
                return item.name == "";
              })
            ) {
              this.showNoHisTip = true;
            } else {
              this.showNoHisTip = false;
            }
            let str = "";
            this.hsitoryDisList.map((item, index) => {
              if (item.radio == 1) {
                if (index == 4 || index == 5) {
                  str += item.name + "异常、";
                } else {
                  str += "有" + item.name + "、";
                }
              }
            });
            if (str == "") {
              this.person[5].text = "无";
            } else {
              this.person[5].text = str.substring(0, str.length - 1);
            }
          });
          console.log(this.hsitoryDisList);
          console.log(this.person);
          // debugger
          if(this.person[3].text=="男"){
            this.hsitoryDisList[3].name = "备孕中"
            this.person[5].testList[3].title="备孕中"
          }

          // // app进来修改
          // if(this.$route.query.appType==1){
          //   // 未接诊、、已拒绝可以修改
          //   if(data.Status==1||data.Status==99){
          //     this.changeData(1)// 修改
          //   }else if(data.Status==9){
          //     Toast("当前问诊正在处理中，无法进行修改")
          //   }else{
          //     Toast("处方不能修改")
          //   }
          // }
        }
      });
    },
    continued(id) {
      GetInquiry({
        InquiryId: id
      })
        .then(res => {
        if (res.code == 1) {
            Toast.loading({
              message: "跳转中",
              duration: 0
            });
            let data = res.InquiryInfo;
            data.PicList.map(item => {
              item.content = item.Url;
            });
            let person = [
              { text: "", tip: "name" },
              { text: "", tip: "carId" },
              { text: "", tip: "bornDate" },
              { text: "", tip: "sex" },
              { text: "", tip: "phone" },
              {
                text: "",
                tip: "about",
                testList: [
                  { name: "", title: "过往病史" },
                  { name: "", title: "过敏史" },
                  { name: "", title: "家族病史" },
                  { name: "", title: "妊娠哺乳" },
                  { name: "", title: "肝功能" },
                  { name: "", title: "肾功能" }
                ]
              }
            ];
            let hsitoryDisList = [
              {
                type: 0,
                name: "过往病史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "先天性心脏病", sel: false, sys: true },
                  { name: "阴道炎", sel: false, sys: true },
                  { name: "月经失调", sel: false, sys: true },
                  { name: "肿瘤", sel: false, sys: true },
                  { name: "动脉硬化", sel: false, sys: true },
                  { name: "脑血管病", sel: false, sys: true },
                  { name: "糖尿病", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 1,
                name: "过敏史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "青霉素", sel: false, sys: true },
                  { name: "动物皮屑", sel: false, sys: true },
                  { name: "尘螨", sel: false, sys: true },
                  { name: "灰尘", sel: false, sys: true },
                  { name: "花粉", sel: false, sys: true },
                  { name: "鸡蛋", sel: false, sys: true },
                  { name: "牛奶", sel: false, sys: true },
                  { name: "鱼,虾,海产品", sel: false, sys: true },
                  { name: "阿司匹林", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 2,
                name: "家族病史",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "先天性心脏病", sel: false, sys: true },
                  { name: "阴道炎", sel: false, sys: true },
                  { name: "月经失调", sel: false, sys: true },
                  { name: "肿瘤", sel: false, sys: true },
                  { name: "动脉硬化", sel: false, sys: true },
                  { name: "脑血管病", sel: false, sys: true },
                  { name: "糖尿病", sel: false, sys: true }
                ],
                showAdd: true
              },
              {
                type: 3,
                name: "妊娠哺乳",
                radio: "0",
                text1: "有",
                text2: "无",
                medList: [
                  { name: "备孕中", sel: false, sys: true },
                  { name: "怀孕中", sel: false, sys: true },
                  { name: "正在哺乳", sel: false, sys: true }
                ],
                showAdd: false
              },
              {
                type: 4,
                name: "肝功能",
                radio: "0",
                text1: "异常",
                text2: "正常",
                medList: [],
                showAdd: false
              },

              {
                type: 5,
                name: "肾功能",
                radio: "0",
                text1: "异常",
                text2: "正常",
                medList: [],
                showAdd: false
              }
            ];
            person[0].text = data.Name;
            person[1].text = data.IDCard;
            person[2].text = data.Birthdate;
            person[3].text = data.Sex == 1 ? "男" : "女";
            person[4].text = data.PhoneNo;
            person[5].text = "";

            hsitoryDisList[0].radio = data.PMHType;
            hsitoryDisList[1].radio = data.AMHType;
            hsitoryDisList[2].radio = data.FMHType;
            hsitoryDisList[3].radio = data.NurseType;
            hsitoryDisList[4].radio = data.LiverType;
            hsitoryDisList[5].radio = data.RenalType;
            // hsitoryDisList.map(item=>{
            //   if(item.radio==1){
            //     person[5].text+=item.name+","
            //   }
            // })
            // person[5].text=person[5].text.substring(0,person[5].text.length-1)

            data.DiseaseList.map(item => {
              item.sel = true;
            });
            data.DrugsList.map(item => {
              item.num = item.Count;
            });

            person[5].testList[0].name = data.PMH || "";
            person[5].testList[1].name = data.AMH || "";
            person[5].testList[2].name = data.FMH || "";
            person[5].testList[3].name = data.NurseDesc || "";
            person[5].testList[4].name = data.LiverDesc || "";
            person[5].testList[5].name = data.RenalDesc || "";
            hsitoryDisList.map((item, index) => {
              let temArr = [];
              let arr = person[5].testList[index].name.split("、");
              item.medList.map((it, inx) => {
                arr.map((items, indexs) => {
                  if (items == it.name) {
                    it.sel = true;
                  }
                });
              });
              // 判断返回的值是否存在不是系统默认的值
              arr.map((items, indexs) => {
                let count = item.medList.every((it, inx) => {
                  return items != it.name;
                });
                if (count) {
                  temArr.push({
                    sys: false,
                    sel: true,
                    name: items
                  });
                  temArr.map(items3 => {
                    if (items3.name) {
                      item.medList.push(items3);
                    }
                  });
                }
              });
            });
            let onlyDrugsList = data.DiseaseList.filter(item => {
              item.isMain == 1;
            });
            if (onlyDrugsList[0]) {
              if (onlyDrugsList[0].DiseaseList.length > 0) {
                onlyDrugsList[0].DiseaseList.map(item => {
                  data.DiseaseList.map(items => {
                    if (item.Name == items.Name) {
                      items.sys = true;
                    }
                  });
                });
              }
            }
            let str = "";
            hsitoryDisList.map((item, index) => {
              if (item.radio == 1) {
                if (index == 4 || index == 5) {
                  str += item.name + "异常、";
                } else {
                  str += "有" + item.name + "、";
                }
              }
            });
            if (str == "") {
              person[5].text = "无";
            } else {
              person[5].text = str.substring(0, str.length - 1);
            }

            sessionStorage.setItem(
              "fillData",
              JSON.stringify({
                currentDate: data.Birthdate,
                diseaseList: data.DiseaseList,
                imgList: data.PicList,
                description: data.SymptomDesc,
                addDrugsList: data.DrugsList,
                hsitoryDisList,
                person,
                weight: data.Weight
              })
            );
            sessionStorage.setItem("firstHis", true);
            console.log(213);
            Toast.clear();
            this.clear = false;
            console.log(JSON.parse(sessionStorage.getItem("fillData")));
            // this.tellIOS();
            sessionStorage.removeItem('his_people')
            this.$router.replace({
              path: "/fill",
              query: { type: "keep", ModeType: data.ModeType }
            });
          } else {
            Toast("请求错误，请稍后再试");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  mounted() {
    // let fillData = JSON.parse(sessionStorage.getItem("fillData"));

    // document.title = this.$route.meta.title
    // app聊天进来重新提交
    if(this.$route.query.appType==2){
      this.continued(this.$route.query.InquiryId)
      return
    }else{
      this.getData();
      this.getEcoData()
    }
    

    if (this.$route.query.DealDesc)
      this.refuseText = this.$route.query.DealDesc;
  },
  beforeDestroy() {
    console.log(this.$router);
    sessionStorage.setItem("unUpdate", true);
  }
};
</script>

<style scoped="scoped" >
@import url("../css/fill-inquiry-information.css");
.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
 .disease {
  background: #fff;
  color: rgba(19, 165, 188, 1);
  border-color: rgba(19, 165, 188, 1);
}
.colon {
  min-width: 80px;
  text-align: justify;
  text-align-last: justify;
  float: left;
}
.uoload_img {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  margin-right: 7px;
}
.uoload_img:last-child {
  margin-right: 0;
}
.imgList {
  flex-wrap: wrap;
}

.symptom_description {
  padding: 0 0 20px 0;
}
.fill_box {
  padding-bottom: 86px;
  background: #f2f2f2;
  padding-top: 10px;
}
.footer {
  justify-content: center;
}
.flex3s {
  justify-content: flex-end;
}
.change_btn {
  width: 75px;
  height: 28px;
  border: 1px solid rgba(22, 174, 202, 1);
  border-radius: 14px;
  text-align: center;
  line-height: 28px;
  font-size: 16px;
  color: rgba(19, 165, 188, 1);
  margin-right: 20px;
}
.back_btn {
  color: rgba(255, 255, 255, 1);
  background: rgba(19, 165, 188, 1);
  margin-left: 10px;
}
.fill_box_tip {
  font-size: 13px;
  font-family: STXihei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin: 4px 0 6px 0;
}
.status_img_in_detail {
  width: 355px;
  height: 85px;
  margin: 0 auto;
  /* // margin-top: 10px; */
}
.in_detail_refuse_box {
  
  background-image: url("../images/d2.png");
  min-height: 85px;
  background-repeat: no-repeat;
  background-size: 100%, 100%;
  margin: 0 auto;
  margin-bottom:5px;
  /* // margin-top: 10px; */
  padding: 0 100px 10px 15px;
  padding-top: 35px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.in_detail_refuse_box_tip {
  font-size: 14px;
  font-family: STXihei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.span-more {
  /* // border: 1px solid red; */
  background-image: url("../images/lock-more.png");
  background-size: 63px 20px;
  background-repeat: no-repeat;
  width: 63px;
  height: 19px;
  border-radius: 10px;
  padding: 0 6px;
  line-height: 19px;
  font-size: 11px;
  color: #ffffff;
  font-family: STXihei;
  position: absolute;
  bottom: 8px;
  right: 90px;
}
.span-more2 {
  background: #129bb1;
  width: 63px;
  height: 19px;
  border-radius: 10px;
  padding: 0px 2px 0 7px;
  line-height: 20px;
  font-size: 11px;
  color: #ffffff;
  font-family: STXihei;
  position: absolute;
  bottom: 8px;
  right: 100px;
}
.chat_img{
  position: fixed;
  bottom: 40px;
  right: 10px;
  width: 80px;
  height: 80px;
  z-index: 10;
}
</style>
